<template>
  <ul class="product-list">
    <li v-for="(product, index) in products" :key="index" class="product-item">
      <img class="product-image" :src="product.image">
      <div class="product-description border-bottom">
        <p class="product-name">
          {{ product.name.length >= 56 ? `${product.name.substring(0, 56)}...` : product.name }}
        </p>
        <p class="product-amount">
          Quantidade: {{ product.amount >= 10 ? product.amount : `0${product.amount}`}}
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'product-list',
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-list {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: scroll;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
      height: calc(100% - 10px);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, .5);
    }
  }

  .product-item {
    display: flex;
    gap: 20px;
    align-items: flex-start;

    .product-image {
      width: 48px;
      height: 48px;
    }

    .product-description {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-bottom: 12px;
      flex: 1px;

      .product-name {
        @extend .x-small-semibold;

        font-family: var(--font-family);
        font-size: 12px;
        line-height: 16px;
      }

      .product-amount {
        @extend .x-small-regular;

        font-family: var(--font-family);
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
</style>
